import React, { createContext, useContext, useReducer } from "react";
const GeneralManagementStateContext = createContext();

const initialState = {
  prestacionActiva: [],
  prestacionGeneral: [],
  expedienteId: null,
  gruposPrestacionActiva: [],
  gruposPrestacionGeneral: [],
  formulariosAutorizaciones: [],
  documentosAutorizaciones: [],
  isActiveCommunication: true,
  loadinGetMyManagement: false,
  successGetMyManagement: false,
  errorGetMyManagement: false,
  countNotice: false,
  showInfoSurvey : true,
  surveys: [],
  showSurvey: { show: false, id: '' }
};

function reducer(state, action) {
  switch (action.type) {
    case "SET_PRESTACION_ACTIVA":
      return { ...state, prestacionActiva: action.payload };
    case "SET_PRESTACION_GENERAL":
      return { ...state, prestacionGeneral: action.payload };
    case "SET_EXPEDIENTE_ID":
      return { ...state, expedienteId: action.payload };
    case "SET_FORMS_AUTORIZACIONES":
      return { ...state, formulariosAutorizaciones: action.payload };
    case "SET_DOCUMENTOS_AUTORIZACIONES":
      return { ...state, documentosAutorizaciones: action.payload };
    case "SET_GRUPOS_PRESTACION_GENERAL":
      return { ...state, gruposPrestacionGeneral: action.payload };
    case "SET_GRUPOS_PRESTACION_ACTIVA":
      return { ...state, gruposPrestacionActiva: action.payload };
    case "SET_LOADING":
      return { ...state, loadinGetMyManagement: action.payload };
    case "SET_SUCCESS":
      return { ...state, successGetMyManagement: action.payload };
    case "SET_ERROR":
      return { ...state, errorGetMyManagement: action.payload };
    case "REFRESH_COUNT_NOTICE":
      return { ...state, countNotice: action.payload };
    case "SHOW_INFO_SURVEY":
      return { ...state, showInfoSurvey: action.payload };
    case "SET_SURVEYS":
      return { ...state, surveys: action.payload };
    case "SHOW_SURVEY":
      return { ...state, showSurvey: action.payload };
    default:
      return state;
  }
}

export const GlobalStateProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <GeneralManagementStateContext.Provider value={{ state, dispatch }}>
      {children}
    </GeneralManagementStateContext.Provider>
  );
};

//  hook para acceder al estado global
export const useGeneralManagementState = () => {
  const context = useContext(GeneralManagementStateContext);
  if (!context) {
    throw new Error(
      "GeneralManagementStateContext debe usarse dentro de un GeneralManagementStateContext Provider "
    );
  }
  return context;
};